var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfCircleDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 2,
    height: 10,
    viewBox: "0 0 2 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0C0 0 0 0 0 0L1 0C1.5522847498307932 0 2 0.44771525016920666 2 1L2 9C2 9.552284749830793 1.5522847498307932 10 1 10L0 10C0 10 0 10 0 10Z",
    fill: "#9557FF",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfCircleDot);
export default __webpack_public_path__ + "static/media/half-circle-dot.f7a737cd1d48781f2db4f99a68456f8a.svg";
export { ForwardRef as ReactComponent };